const checkUpdates = (registration, intervalMinutes) => {
	if (registration && registration.update) {
		registration.update();
		setTimeout(function () {
			checkUpdates(registration);
		}, 1000 * 60 * intervalMinutes);
	}
}

export const serviceWorkerRegistrationCheckForUpdates = (config, registration, intervalMinutes = 1) => {
	checkUpdates(registration, intervalMinutes);

	registration.addEventListener('updatefound', () => {
		const newWorker = registration.installing;
		newWorker.addEventListener('statechange', () => {
			if (newWorker.state === 'activated' && config && config.onActivated) {
				config.onActivated(registration);
			}
		});
	});
}